export const UserIcon = (props) => {
  return (
    <svg
      width="18"
      height="25"
      viewBox="0 0 18 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M9 12.5C10.1867 12.5 11.3467 12.1334 12.3334 11.4467C13.3201 10.7599 14.0892 9.78381 14.5433 8.64177C14.9974 7.49973 15.1162 6.24307 14.8847 5.03069C14.6532 3.81831 14.0818 2.70466 13.2426 1.83058C12.4035 0.956507 11.3344 0.361252 10.1705 0.120095C9.00666 -0.121063 7.80026 0.00270804 6.7039 0.475756C5.60754 0.948803 4.67047 1.74988 4.01118 2.77769C3.35189 3.8055 3 5.01387 3 6.25C3.00159 7.9071 3.63424 9.49585 4.75911 10.6676C5.88399 11.8393 7.40919 12.4983 9 12.5ZM9 2.08334C9.79112 2.08334 10.5645 2.32771 11.2223 2.78555C11.8801 3.24338 12.3928 3.89413 12.6955 4.65549C12.9983 5.41685 13.0775 6.25462 12.9231 7.06288C12.7688 7.87113 12.3878 8.61356 11.8284 9.19628C11.269 9.779 10.5563 10.1758 9.78036 10.3366C9.00444 10.4974 8.20017 10.4149 7.46927 10.0995C6.73836 9.78413 6.11365 9.25008 5.67412 8.56488C5.2346 7.87967 5 7.07409 5 6.25C5 5.14493 5.42143 4.08512 6.17157 3.30372C6.92172 2.52232 7.93913 2.08334 9 2.08334Z"
        fill="white"
      />
      <path
        d="M9 14.5834C6.61386 14.5861 4.32622 15.5747 2.63896 17.3323C0.951708 19.0899 0.00264685 21.4728 0 23.9584C0 24.2346 0.105357 24.4996 0.292893 24.695C0.480429 24.8903 0.734783 25 1 25C1.26522 25 1.51957 24.8903 1.70711 24.695C1.89464 24.4996 2 24.2346 2 23.9584C2 22.0245 2.7375 20.1698 4.05025 18.8024C5.36301 17.4349 7.14348 16.6667 9 16.6667C10.8565 16.6667 12.637 17.4349 13.9497 18.8024C15.2625 20.1698 16 22.0245 16 23.9584C16 24.2346 16.1054 24.4996 16.2929 24.695C16.4804 24.8903 16.7348 25 17 25C17.2652 25 17.5196 24.8903 17.7071 24.695C17.8946 24.4996 18 24.2346 18 23.9584C17.9973 21.4728 17.0483 19.0899 15.361 17.3323C13.6738 15.5747 11.3861 14.5861 9 14.5834Z"
        fill="white"
      />
    </svg>
  );
};

export const CartIcon = (props) => {
  return (
    <svg
      width="25"
      height="27"
      viewBox="0 0 25 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M24.2635 4.91831C23.9669 4.54513 23.5955 4.24499 23.1758 4.03921C22.7561 3.83343 22.2983 3.72707 21.8349 3.72766H4.78571L4.74142 3.33962C4.65078 2.53304 4.28101 1.78937 3.70219 1.24959C3.12338 0.709811 2.37577 0.41145 1.6011 0.411072L1.367 0.411072C1.08733 0.411072 0.819115 0.527547 0.621357 0.734874C0.423599 0.9422 0.3125 1.2234 0.3125 1.5166C0.3125 1.8098 0.423599 2.091 0.621357 2.29833C0.819115 2.50565 1.08733 2.62213 1.367 2.62213H1.6011C1.85939 2.62216 2.10868 2.72158 2.30169 2.90151C2.4947 3.08145 2.61801 3.32939 2.64823 3.59831L4.09923 16.533C4.24986 17.8782 4.86635 19.1186 5.83168 20.0187C6.79701 20.9189 8.04398 21.4161 9.3359 21.4161H20.3481C20.6278 21.4161 20.896 21.2996 21.0937 21.0923C21.2915 20.885 21.4026 20.6038 21.4026 20.3106C21.4026 20.0174 21.2915 19.7362 21.0937 19.5289C20.896 19.3215 20.6278 19.2051 20.3481 19.2051H9.3359C8.68322 19.2031 8.04708 18.9896 7.5147 18.5938C6.98232 18.1979 6.57975 17.6391 6.36219 16.994H18.9319C20.1681 16.9941 21.365 16.5388 22.3135 15.7077C23.262 14.8765 23.9018 13.7224 24.1211 12.447L24.9489 7.63349C25.0315 7.15591 25.013 6.66512 24.8945 6.1959C24.7761 5.72668 24.5606 5.29052 24.2635 4.91831ZM22.8789 7.24103L22.0501 12.0545C21.9184 12.8206 21.5338 13.5138 20.9638 14.0126C20.3937 14.5114 19.6744 14.7841 18.9319 14.7829H6.02686L5.03457 5.93872H21.8349C21.9898 5.93775 22.1431 5.97257 22.2837 6.04071C22.4243 6.10884 22.5489 6.20863 22.6485 6.33295C22.7482 6.45728 22.8205 6.60311 22.8603 6.76005C22.9001 6.917 22.9065 7.08122 22.8789 7.24103Z"
        fill="white"
      />
      <path
        d="M7.69495 26.9437C8.85972 26.9437 9.80395 25.9538 9.80395 24.7327C9.80395 23.5115 8.85972 22.5216 7.69495 22.5216C6.53017 22.5216 5.58594 23.5115 5.58594 24.7327C5.58594 25.9538 6.53017 26.9437 7.69495 26.9437Z"
        fill="white"
      />
      <path
        d="M18.2379 26.9437C19.4027 26.9437 20.3469 25.9538 20.3469 24.7327C20.3469 23.5115 19.4027 22.5216 18.2379 22.5216C17.0731 22.5216 16.1289 23.5115 16.1289 24.7327C16.1289 25.9538 17.0731 26.9437 18.2379 26.9437Z"
        fill="white"
      />
    </svg>
  );
};

export const FavoritesIcon = (props) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <g clipPath="url(#clip0_75_571)">
        <path
          d="M17.5009 1.99689C16.3749 2.01513 15.2734 2.34257 14.3077 2.94613C13.342 3.54969 12.5463 4.408 12.0009 5.43439C11.4556 4.408 10.6599 3.54969 9.69417 2.94613C8.72847 2.34257 7.62698 2.01513 6.50093 1.99689C4.70588 2.07813 3.01464 2.89611 1.79672 4.27213C0.578794 5.64815 -0.0668157 7.47035 0.000934853 9.34064C0.000934853 14.0771 4.78693 19.25 8.80093 22.7573C9.69715 23.5418 10.8303 23.9719 12.0009 23.9719C13.1716 23.9719 14.3047 23.5418 15.2009 22.7573C19.2149 19.25 24.0009 14.0771 24.0009 9.34064C24.0687 7.47035 23.4231 5.64815 22.2052 4.27213C20.9872 2.89611 19.296 2.07813 17.5009 1.99689ZM13.9159 21.1636C13.3799 21.6337 12.7017 21.8916 12.0009 21.8916C11.3002 21.8916 10.622 21.6337 10.0859 21.1636C4.94793 16.6729 2.00093 12.3646 2.00093 9.34064C1.93258 8.02263 2.3673 6.72994 3.2103 5.74449C4.05329 4.75904 5.23617 4.16079 6.50093 4.08022C7.7657 4.16079 8.94857 4.75904 9.79157 5.74449C10.6346 6.72994 11.0693 8.02263 11.0009 9.34064C11.0009 9.6169 11.1063 9.88186 11.2938 10.0772C11.4814 10.2726 11.7357 10.3823 12.0009 10.3823C12.2662 10.3823 12.5205 10.2726 12.708 10.0772C12.8956 9.88186 13.0009 9.6169 13.0009 9.34064C12.9326 8.02263 13.3673 6.72994 14.2103 5.74449C15.0533 4.75904 16.2362 4.16079 17.5009 4.08022C18.7657 4.16079 19.9486 4.75904 20.7916 5.74449C21.6346 6.72994 22.0693 8.02263 22.0009 9.34064C22.0009 12.3646 19.0539 16.6729 13.9159 21.1594V21.1636Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_75_571">
          <rect width="24" height="25" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ExitIcon = (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_75_574)">
        <path
          d="M11.2788 13.0708H12.6844V15.8818C12.6844 17.0443 11.7386 17.99 10.5761 17.99H2.10814C0.945786 17.99 0 17.0443 0 15.8818V2.10814C0 0.945786 0.945786 0 2.10814 0H10.5761C11.7386 0 12.6844 0.945786 12.6844 2.10814V4.91913H11.2788V2.10814C11.2788 1.72073 10.9637 1.40543 10.5761 1.40543H2.10814C1.72073 1.40543 1.40543 1.72073 1.40543 2.10814V15.8818C1.40543 16.2692 1.72073 16.5845 2.10814 16.5845H10.5761C10.9637 16.5845 11.2788 16.2692 11.2788 15.8818V13.0708ZM14.6872 5.68213L13.6934 6.67598L15.3096 8.29234H6.21922V9.69777H15.3096L13.6934 11.314L14.6872 12.3078L18 8.99506L14.6872 5.68213Z"
          fill="#0B3F37"
        />
      </g>
      <defs>
        <clipPath id="clip0_75_574">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DownloadIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.2012 13.6011H0.800065C0.587875 13.6011 0.384375 13.6854 0.234334 13.8354C0.0842923 13.9854 0 14.189 0 14.4011C0 14.6133 0.0842923 14.8168 0.234334 14.9669C0.384375 15.1169 0.587875 15.2012 0.800065 15.2012H15.2012C15.4134 15.2012 15.6169 15.1169 15.767 14.9669C15.917 14.8168 16.0013 14.6133 16.0013 14.4011C16.0013 14.189 15.917 13.9854 15.767 13.8354C15.6169 13.6854 15.4134 13.6011 15.2012 13.6011Z"
        fill="url(#paint0_linear_75_618)"
      />
      <path
        d="M7.99898 0C7.78679 0 7.58329 0.0842923 7.43325 0.234334C7.2832 0.384375 7.19891 0.587875 7.19891 0.800065V9.27276L4.5667 6.63254C4.41604 6.48188 4.21171 6.39725 3.99865 6.39725C3.78559 6.39725 3.58126 6.48188 3.43061 6.63254C3.27995 6.7832 3.19531 6.98753 3.19531 7.20059C3.19531 7.41365 3.27995 7.61798 3.43061 7.76863L7.43093 11.769C7.50531 11.8439 7.5938 11.9035 7.69129 11.9441C7.78879 11.9847 7.89336 12.0056 7.99898 12.0056C8.1046 12.0056 8.20917 11.9847 8.30666 11.9441C8.40416 11.9035 8.49265 11.8439 8.56702 11.769L12.5673 7.76863C12.6419 7.69404 12.7011 7.60548 12.7415 7.50801C12.7819 7.41055 12.8026 7.30608 12.8026 7.20059C12.8026 7.09509 12.7819 6.99063 12.7415 6.89316C12.7011 6.7957 12.6419 6.70714 12.5673 6.63254C12.4928 6.55794 12.4042 6.49877 12.3067 6.4584C12.2093 6.41803 12.1048 6.39725 11.9993 6.39725C11.8938 6.39725 11.7893 6.41803 11.6919 6.4584C11.5944 6.49877 11.5059 6.55794 11.4313 6.63254L8.79904 9.27276V0.800065C8.79904 0.587875 8.71475 0.384375 8.56471 0.234334C8.41467 0.0842923 8.21117 0 7.99898 0Z"
        fill="url(#paint1_linear_75_618)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_75_618"
          x1="3.56371"
          y1="13.025"
          x2="15.1509"
          y2="17.4354"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5E3928" />
          <stop offset="0.911458" stopColor="#E4A16F" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_75_618"
          x1="5.335"
          y1="-4.32202"
          x2="13.2926"
          y2="-4.07964"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5E3928" />
          <stop offset="0.911458" stopColor="#E4A16F" />
        </linearGradient>
      </defs>
    </svg>
  );
};
